<template>
  <div :key="componentKey">
    <div :class="scrollHorizontal ? 'd-flex flex-no-wrap' : 'd-flex flex-wrap' "
          :style="scrollHorizontal ? 'overflow-x:scroll;':''">
      <div v-for="card in cards" :key="card[identifierKey]">
        <slot name="card" v-bind="{ card }" >
          <v-card
            @click="cardsClickable ? emit('card-click', card) : null"
            v-if="!card.hide && isVisible"
            :class="classes['card']"
            :style="localSyle['card']"
            :color="card.color ? card.color : color"
            :max-height="card.maxHeight || cardsMaxHeight"
            :max-width="card.maxWidth || cardsMaxWidth"
            :min-height="card.minHeight || cardsMinHeight"
            :min-width="card.minWidth || cardsMinWidth"
          >
            <div class="d-flex flex-column" style="height: 100%">
              <div>
                <v-row v-if="showAvatar">
                  <v-col cols="6">
                    <v-avatar class="ma-2">
                      <img
                        src="https://cdn.vuetifyjs.com/images/john.jpg"
                        alt="John"
                      />
                    </v-avatar>
                  </v-col>
                  <v-card-title class="" v-text="card.title"> </v-card-title>
                </v-row>
                <v-card-title v-else v-text="card.title"> </v-card-title>

                <v-card-subtitle v-text="card.subTitle"></v-card-subtitle>
                <v-card-text v-text="card.text"></v-card-text>
              </div>
              <v-card-actions class="mt-auto">
                <v-spacer></v-spacer>
                <slot :name="card[identifierKey] + '-actions'">
                  <v-btn
                    :class="classes['actions']"
                    :style="styles['actions']"
                    icon
                    v-for="(action, index) in card.actions"
                    :key="index"
                    @click="emit('action-clicked', action.name, card)"
                  >
                    <v-icon :color="action.color || buttonsColor">{{
                      action.icon
                    }}</v-icon>
                  </v-btn>
                </slot>
              </v-card-actions>
            </div>
          </v-card>
        </slot>
      </div>

      <v-card
        v-if="showLoadMoreIn == 'card'"
        flat
        class="d-flex justify-center align-center"
        :class="classes['card']"
        :style="styles['card']"
        :max-height="cardsMaxHeight"
        :max-width="cardsMaxWidth"
        :min-height="cardsMinHeight"
        :min-width="cardsMinWidth"
      >
        <v-btn
          icon
          :loading="loadingMore"
          v-if="!finishLoading"
          @click="loadMore"
        >
          <v-icon>{{ loadMoreIcon }}</v-icon>
        </v-btn>
        <span v-else class="font-weight-light">
          {{ cards.length }} di {{ cards.length }}
        </span>
      </v-card>
    </div>
    <div v-if="showLoadMoreIn == 'footer'" class="d-flex justify-center my-2">
      <v-btn
        icon
        :loading="loadingMore"
        v-if="!finishLoading"
        @click="loadMore"
      >
        <v-icon>{{ loadMoreIcon }}</v-icon>
      </v-btn>
      <span v-else class="font-weight-light">
        {{ cards.length }} di {{ cards.length }}
      </span>
    </div>
  </div>
</template>

<script>
import emittable from "../../mixins/emittable.js";

import {
  VCard,
  VCardTitle,
  VCardSubtitle,
  VCardText,
  VCardActions,
  VIcon,
  VBtn,
  VSpacer,
  VRow,
  VCol,
  VAvatar,
} from "vuetify/lib";

export default {
  mixins: [emittable],
  components: {
    VCard,
    VCardTitle,
    VCardSubtitle,
    VCardText,
    VCardActions,
    VIcon,
    VBtn,
    VSpacer,
    VRow,
    VCol,
    VAvatar,
  },
  data: function () {
    let ls = { ...this.styles };
    if (!ls["card"]) {
      ls["card"] = {};
    }

    if (!ls["card"]["margin"]) {
      ls["card"]["margin"] = this.margin;
    }

    return {
      localSyle: ls,
      componentKey: 0,
    };
  },
  props: {
    cards: {
      type: Array,
      default: function () {
        return [];
      },
    },
    color: {
      type: String,
      default: undefined,
    },
    margin: {
      type: String,
      default: "10px",
    },
    buttonsColor: {
      type: String,
      default: undefined,
    },
    cardsMinWidth: {
      type: String,
      default: "200px",
    },
    cardsMinHeight: {
      type: String,
      default: "200px",
    },
    cardsMaxWidth: {
      type: String,
      default: "300px",
    },
    cardsMaxHeight: {
      type: String,
      default: "300px",
    },
    identifierKey: {
      type: String,
      default: "title",
    },
    loadMoreColor: {
      type: String,
      default: "primary",
    },
    loadingMore: {
      type: Boolean,
      default: false,
    },
    finishLoading: {
      type: Boolean,
      default: false,
    },
    loadMoreIcon: {
      type: String,
      default: "mdi-reload",
    },
    showLoadMoreIn: {
      type: String,
      default: "card",
      validator: function (value) {
        return ["card", "footer", "none"].indexOf(value) !== -1;
      },
    },
    isVisible: {
      type: Boolean,
      default: true,
    },
    showAvatar: {
      type: Boolean,
      default: false,
    },
    cardsClickable: {
      type: Boolean,
      default: false,
    },
    scrollHorizontal: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: function () {
        return {
          card: {},
          actions: {},
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          card: {},
          actions: {},
        };
      },
    },
  },
  computed: {},
  methods: {
    loadMore() {
      this.emit("load-more", this.cards.length);
    },
  },
  watch: {
    cards() {
      this.componentKey++;
    },
  },
};
</script>

<style scoped>
</style>